import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../landingPage/components/Footer";
import { Helmet } from "react-helmet-async";

export function PrivacyTermsPage() {
  return (
    <div className="min-h-screen w-full flex flex-col bg-white text-neutral-900">
      <Helmet>
        <title>Política de Privacidade e Termos de Uso - Clocker</title>
      </Helmet>
      <Navbar />
      <main className="flex-1 w-full max-w-screen-lg mx-auto px-4 py-8 space-y-8">
        <section className="space-y-4">
          <h1 className="text-3xl font-bold">Política de Privacidade</h1>
          <p>
            O Clocker é um sistema de gestão de atendimentos. Coletamos dados como
            nome, e-mail, telefone, horários e informações das consultas para viabilizar
            o agendamento, gerar métricas e permitir o contato com seus clientes e
            funcionários.
          </p>
          <p>
            Esses dados são utilizados apenas para operar e aprimorar o serviço. Não
            vendemos suas informações e compartilhamos apenas com provedores
            essenciais, como processadores de pagamento.
          </p>
          <p>
            Você pode solicitar correção ou exclusão dos seus dados entrando em
            contato pelos canais disponíveis no rodapé.
          </p>
        </section>
        <section className="space-y-4">
          <h2 className="text-3xl font-bold">Termos de Uso</h2>
          <p>
            Ao utilizar o Clocker você concorda em fornecer informações verídicas e
            usar a plataforma apenas para organizar seus atendimentos.
          </p>
          <p>
            Planos pagos são processados por terceiros e o não pagamento poderá
            resultar na suspensão de recursos premium.
          </p>
          <p>
            Podemos suspender contas que usem o serviço de forma ilícita ou em
            desacordo com estes termos.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default PrivacyTermsPage;
